<template>
  <div class="error-page">
    <sup>{{ $t(`${code}.sup`) }}</sup>
    <h1>{{ $t(`${code}.title`) }}</h1>
    <p>
      {{ $t(`${code}.message`) }}
    </p>
    <!-- <a :href="target || '#'" @click="back" class="btn btn-success">{{ $i18n.t(`errors.${code}.button`) }}</a> -->
  </div>
</template>

<script>
export default {
  name: 'error',
  i18nOptions: { keyPrefix: 'views.error-page.errors' },
  props: ['code', 'target'],
  methods: {
    back(e) {
      if (e.target.href.endsWith('#')) {
        history.back()
        e.preventDefault()
      }
    },
  },
  created() {
    document.getElementsByTagName('html')[0].classList.add('error-' + this.$props.code)
    document.getElementsByTagName('html')[0].classList.add('fullbg')
  },
}
</script>

<style lang="scss">
.error-403 {
  background-image: url('~@/assets/errors/403.png') !important;
}

.error-404 {
  background-image: url('~@/assets/errors/404.png') !important;
}

.error-500 {
  background-image: url('~@/assets/errors/500.png') !important;
}

.error-502 {
  background-image: url('~@/assets/errors/502.png') !important;
}

.error-503 {
  background-image: url('~@/assets/errors/503.png') !important;
}

.error-504 {
  background-image: url('~@/assets/errors/504.png') !important;
}

.fullbg {
  background: no-repeat center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}

.error-page {
  margin: 0;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 50% !important;
  color: white !important;
  font-family: 'Open Sans', 'Helvetica Neue', sans-serif;
  font-weight: 400;

  sup {
    font-size: 1.25em;
    font-family: 'Raleway', 'Roboto';
    font-weight: 700;
    text-transform: uppercase;
    top: 0.5em;
  }

  h1 {
    font-size: 4em;
    font-family: 'Raleway', 'Roboto';
    font-weight: 900;
    text-transform: uppercase;
  }

  p {
    font-size: 1.5em;
  }

  a {
    border-radius: 27px;
    margin: 10px;
    padding: 5px 15px 5px 15px;
    font-size: 1.25em;
    font-weight: 600;
  }
}
</style>
